import { useEffect, useMemo, useRef } from 'react';
import { useExtensions } from '../../extensions/useExtensions.js';

export function useBlocksComponentsRef() {
  const { getExtensions } = useExtensions();

  const blocksComponents = useMemo(
    () => ({
      widgets: getExtensions('BlocksWidget'),
      panels: getExtensions('BlocksWidgetPanel'),
    }),
    [getExtensions]
  );

  const blocksComponentsRef = useRef(blocksComponents);

  useEffect(() => {
    blocksComponentsRef.current = blocksComponents;
  }, [blocksComponents]);

  return blocksComponentsRef;
}
